import { differenceInDays, differenceInHours, differenceInMinutes } from 'date-fns';
import { useEffect, useState } from 'react';
import { Appointment } from '../../types/booking';

interface HostProps {
	appointmentStartDateTime: Appointment['startDatetime'];
	getLabel: (key: string) => string;
	hostImageUrl?: string;
	hostName?: string;
}

export default function Host({ appointmentStartDateTime, getLabel, hostImageUrl, hostName }: HostProps) {
	const [timeMessage, setTimeMessage] = useState('');

	useEffect(() => {
		const updateTimeMessage = () => {
			const appointmentDate = new Date(appointmentStartDateTime);
			const now = new Date();

			const days = differenceInDays(appointmentDate, now);
			const hours = differenceInHours(appointmentDate, now);
			const minutes = differenceInMinutes(appointmentDate, now);

			// Don't render message if appointment is in the past
			if (minutes <= 0) {
				setTimeMessage('');
				return;
			}

			let timeUnit: string;

			if (days > 0) {
				const label = days === 1 ? getLabel('appointment_info_host_message_day') : getLabel('appointment_info_host_message_days');
				timeUnit = label.replace('%d', `<strong>${days}</strong>`);
			} else if (hours > 0) {
				const label = hours === 1 ? getLabel('appointment_info_host_message_hour') : getLabel('appointment_info_host_message_hours');
				timeUnit = label.replace('%d', `<strong>${hours}</strong>`);
			} else {
				const label = minutes === 1 ? getLabel('appointment_info_host_message_minute') : getLabel('appointment_info_host_message_minutes');
				timeUnit = label.replace('%d', `<strong>${minutes}</strong>`);
			}

			setTimeMessage(timeUnit);
		};

		updateTimeMessage();
		const interval = setInterval(updateTimeMessage, 60000); // Update every minute

		return () => clearInterval(interval);
	}, [appointmentStartDateTime, getLabel]);

	return (
		<div className="appointment-info__host">
			{hostImageUrl && (
				<div className="appointment-info__host-image">
					{timeMessage && <div className="appointment-info__host-message" dangerouslySetInnerHTML={{ __html: timeMessage }} />}
					<img src={hostImageUrl} alt={hostName} />
				</div>
			)}
			<b>{getLabel('appointment_info_host')}</b>
			<p>{hostName}</p>
		</div>
	);
}
